<template>
  <div>
    <v-icon @click="settingsModal = true; vibrationHelper()">
      mdi-cog mdi-light
    </v-icon>

    <v-dialog v-model="settingsModal" width="600">
      <v-card>
        <v-card-title>
          設定
        </v-card-title>

        <v-card-text>
          <!-- Location -->
          <v-row>
            <v-col>
              地區
              <v-autocomplete :items="settings.locationOptions" v-model="settings.locationModel"></v-autocomplete>
            </v-col>
          </v-row>

          <!-- Language -->
          <v-row>
            <v-col>
              語言
              <v-radio-group v-model="settings.langModel" row>
                <!-- <v-radio v-for="l in settings.langOptions" :key="l" :label="l" :value="l"></v-radio> -->
                <v-radio label="tc" value="tc"></v-radio>
                <v-radio label="sc" value="sc" disabled></v-radio>
                <v-radio label="en" value="en" disabled></v-radio>

              </v-radio-group>
            </v-col>
          </v-row>

          <!-- Refresh Interval -->
          <v-row>
            <v-col>
              更新間距
              <v-radio-group v-model="settings.refreshModel" row>
                <v-radio v-for="l in settings.refreshOptions" :key="l.value" :label="l.label" :value="l.value"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="settingsModal = false; vibrationHelper()">收皮</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return ({
      // settingsModal: true,
      settingsModal: false,
      settings: {
        locationOptions: ['京士柏','香港天文台','黃竹坑','打鼓嶺','流浮山','大埔','沙田','屯門','將軍澳','西貢','長洲','赤鱲角','青衣','石崗','荃灣可觀','荃灣城門谷','香港公園','筲箕灣','九龍城','跑馬地','黃大仙','赤柱','觀塘','深水埗','啟德跑道公園','元朗公園','大美督'],
        locationModel: '',

        langOptions: ['tc', 'sc', 'en'],
        langModel: '',

        refreshOptions: [
          {
            label: '10秒',
            value: 10000
          },
          {
            label: '30秒',
            value: 30000
          },
          {
            label: '1分鐘',
            value: 60000
          },
          {
            label: '5分鐘',
            value: 300000
          },
          {
            label: '10分鐘',
            value: 600000
          },
          {
            label: '15分鐘',
            value: 900000
          },
        ],
        refreshModel: '',
      }
    })
  },
  watch: {
    'settings.locationModel'(location){
      localStorage.setItem('location', location);

      this.$store.commit('mutateSettingsLocation', location)
    },
    'settings.langModel'(lang){
      localStorage.setItem('lang', lang);

      this.$store.commit('mutateSettingsLang', lang)
    },
    'settings.refreshModel'(refresh){
      localStorage.setItem('refreshInterval', refresh);

      this.$store.commit('mutateSettingsRefresh', refresh)
    },
  },
  methods: {
    mapSettings(){
      this.settings.locationModel = this.$store.state.settings.location;
      this.settings.langModel = this.$store.state.settings.lang;
      this.settings.refreshModel = this.$store.state.settings.refreshInterval;
    }
  },
  created(){
    this.mapSettings();
  }
}
</script>

<style lang="css">
</style>
